import { render } from "./DashboardLayout.vue?vue&type=template&id=1e185751&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "../css/adminlte.css?vue&type=style&index=0&id=1e185751&lang=css&scoped=true&external"
import "./DashboardLayout.vue?vue&type=style&index=1&id=1e185751&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e185751"]])

export default __exports__